import { Component, Fragment } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { isFiltered, sortTable } from '../../libs/tableUtilities';
import Table from '@material-ui/core/Table';
import EnhancedTableHead from './EnhancedTableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { getGlobalClasses } from '../../themes';

import { PureRecordRow } from '../../libs/tableUtilities';

const invoiceStatusClassNames = {
	open: {
		fontWeight: 900,
		color: '#2196F3',
	},
	pendingDriverReport: {
		fontWeight: 900,
		color: '#FF9800',
	},
	error: {
		fontWeight: 900,
		color: '#FF500F',
	},
	invalid: {
		color: '#616161',
		fontWeight: 900,
	},
	complete: {
		fontWeight: 900,
		color: '#4CAF50',
	},
};

const statusToDisplay = {
	open: 'Open',
	pendingDriverReport: 'Pending Employee',
	error: 'Error',
	invalid: 'Invalid',
	complete: 'Complete',
};

const openTicketColumns = [
	{
		id: 'ticketId',
		label: 'Ticket #',
	},
	{
		id: 'fullTicketCategory',
		label: 'Category',
	},
	{
		id: 'openedBySort',
		label: 'Opened By',
	},
	{
		id: 'assignedToSort',
		label: 'Assigned To',
	},
	{
		id: 'details',
		label: 'Details',
	},
	{
		id: 'status',
		label: 'Status',
	},
	{
		id: 'edit',
		label: 'Edit',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		...invoiceStatusClassNames,
		table: {
			width: '100%',
			tableLayout: 'auto',
		},
		fleet: {
			textTransform: 'uppercase',
			paddingRight: 5,
			color: '#777',
		},
		fleetValue: {
			textTransform: 'uppercase',
			color: '#555',
		},
		detailLabel: {
			paddingRight: 5,
		},
		detailValue: {
			fontWeight: 600,
		},
		dateOpened: {
			color: '#555',
		},
	};
};

class TicketTable extends Component {
	constructor(props) {
		super(props);

		this.state = {
			order: 'desc',
			orderBy: 'ticketId',
			//isViewDialogOpen: false,
		};
	}

	handleSort = (orderBy) => {
		let order = 'desc';
		if (this.state.orderBy === orderBy && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	};

	handleEdit = (ticketId) => {
		this.props.history.push(`/ticket/update/${ticketId}`);
	};

	render() {
		const { classes, tickets, ticketCategoryMap, ticketSchemaMap, userMap, filter } = this.props;
		const { order, orderBy } = this.state;

		if (!tickets) {
			return <div>Fetching tickets...</div>;
		}

		let rows = [];
		tickets.forEach((ticket) => {
			const {
				ticketId,
				status,
				dateCreated,
				ticketCategoryId,
				assignedToUserId,
				ticketSchemaId,
				schemaValues,
				creatorUserId,
			} = ticket;

			let ticketCategoryDisplay = '';

			const ticketCategory = ticketCategoryMap[ticketCategoryId];
			if (!ticketCategory) {
				ticketCategoryDisplay = 'MISSING';
			} else {
				ticketCategoryDisplay = ticketCategory.displayName;
			}
			let fullTicketCategory = ticketCategoryDisplay;

			/** @namespace ticketCategory.parentTicketCategoryIds **/
			const parentTicketCategoryId = _.first(ticketCategory.parentTicketCategoryIds);
			const parentTicketCategory = ticketCategoryMap[parentTicketCategoryId];
			if (parentTicketCategory) {
				ticketCategoryDisplay = (
					<div>
						{parentTicketCategory.displayName} /<br />
						{ticketCategoryDisplay}
					</div>
				);
				fullTicketCategory = `${parentTicketCategory.displayName} / ${ticketCategoryDisplay}`;
			}

			const assignedToUser = userMap[assignedToUserId] || { firstName: 'Missing', lastName: '' };

			let assignedToDisplay = '';
			let assignedToSort = `${assignedToUser.firstName} ${assignedToUser.lastName}`;

			/** @namespace schemaValues.fleet **/
			if (schemaValues.fleetDepartment) {
				assignedToDisplay = (
					<div>
						<div>
							<strong>
								{assignedToUser.firstName} {assignedToUser.lastName}
							</strong>
						</div>
						<div>
							<span className={classes.fleet}>Fleet/Dept :</span>
							<span className={classes.fleetValue}>{schemaValues.fleetDepartment}</span>
						</div>
					</div>
				);
			} else {
				assignedToDisplay = (
					<strong>
						{assignedToUser.firstName} {assignedToUser.lastName}
					</strong>
				);
			}

			const ticketSchema = ticketSchemaMap[ticketSchemaId];
			let detailRows = [];
			let detailSort = '';
			if (ticketSchema) {
				ticketSchema.items.forEach((item, index) => {
					const { path, label } = item;

					/** @namespace item.includeInDetails **/
					if (!item.includeInDetails) {
						return;
					}

					let value = schemaValues[path];
					if (_.isUndefined(value)) {
						return;
					}

					let sort = index + 100;

					if (path === 'driverUserId' || path === 'assignedToDriverUserId') {
						const driverUser = userMap[value] || { firstName: 'Missing', lastName: '' };
						value = `${driverUser.firstName} ${driverUser.lastName}`;
						sort = 0;
					}

					detailRows.push({
						path,
						label,
						value,
						sort,
					});

					detailSort += ' ' + value;
				});
			}

			const detailDisplay = _.sortBy(detailRows, 'sort').map(({ path, label, value }) => {
				return (
					<div key={path}>
						<span className={classes.detailLabel}>{label} : </span>
						<span className={classes.detailValue}>{value}</span>
					</div>
				);
			});

			const dateCreatedFormatted = moment(dateCreated).format('M/D, h:mm a');

			const creatorUser = userMap[creatorUserId] || { firstName: 'Missing', lastName: '' };
			const openedBySort = creatorUserId;
			const openedByDisplay = (
				<div>
					<div>
						{creatorUser.firstName} {creatorUser.lastName}
					</div>
					<div className={classes.dateOpened}>@ {dateCreatedFormatted}</div>
				</div>
			);

			const row = {
				ticketId,
				fullTicketCategory,
				ticketCategoryDisplay,
				dateCreatedFormatted,
				assignedToDisplay,
				assignedToSort,
				detailDisplay,
				status,
				statusDisplay: statusToDisplay[status] || status,
				detailSort,
				openedBySort,
				openedByDisplay,
			};

			if (isFiltered({ filter, row, fields: ['ticketId', 'assignedToSort', 'detailSort'] })) {
				return;
			}

			//- Driver
			rows.push(row);
		});

		rows = sortTable({ rows, order, orderBy });

		return (
			<Fragment>
				<Table size="small" className={classes.table}>
					<EnhancedTableHead
						columns={openTicketColumns}
						order={order}
						orderBy={orderBy}
						onRequestSort={this.handleSort}
					/>
					<TableBody>
						{rows.map((row) => {
							return (
								<PureRecordRow hover className={classes.row} key={row.ticketId}>
									<TableCell>{row.ticketId}</TableCell>
									<TableCell>{row.ticketCategoryDisplay}</TableCell>
									<TableCell>{row.openedByDisplay}</TableCell>
									<TableCell>{row.assignedToDisplay}</TableCell>
									<TableCell>{row.detailDisplay}</TableCell>
									<TableCell className={classes[row.status]}>{row.statusDisplay}</TableCell>
									<TableCell align={'center'} style={{ whiteSpace: 'nowrap' }}>
										<Button
											className={classes.button}
											onClick={() => this.handleEdit(row.ticketId)}
										>
											Edit
										</Button>
									</TableCell>
								</PureRecordRow>
							);
						})}
					</TableBody>
				</Table>
			</Fragment>
		);
	}
}

TicketTable.propTypes = {
	classes: PropTypes.object.isRequired,
	filter: PropTypes.string,
	tickets: PropTypes.array,
	ticketCategoryMap: PropTypes.object,
	ticketSchemaMap: PropTypes.object,
	userMap: PropTypes.object,

	history: PropTypes.object.isRequired,
	theme: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles, { withTheme: true })])(TicketTable);
